import React, { useState } from "react";
import "./Units.css";

export default function Units({ weatherDetail }) {
  let [unit, setUnit] = useState("celsius");

  const fahrenheit = Math.round((weatherDetail.temperature * 9) / 5) + 32;

  function handleTempF() {
    setUnit("fahrenheit");
  }

  function handleCelsius() {
    setUnit("celsius");
  }

  return (
    <div style={{ display: "flex" }}>
      <strong style={{ marginTop: "-15px" }}>
        {unit === "celsius" ? weatherDetail.temperature : fahrenheit}
      </strong>
      <p className="units">
        <span className="celsius" onClick={handleCelsius}>
          °C
        </span>
        <span> | </span>
        <span className="farenheit" onClick={handleTempF}>
          F
        </span>
      </p>
    </div>
  );
}
